import { Box, Container, Typography,Tab } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Sidebar from "../../../../TutorDashboard/Components/sidebarAdmin";
import Header from "../../../../TutorDashboard/Components/headerAdmin";
import ExamArenaTopSection from "../components/ExamArenaTopSection";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ExamArenaBottomSection from "../components/ExamArenaBottomSection";
import Interview from "../components/Interview";
import ExamResults from "../components/ExamResults";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setExamResultsArr } from "../../../../../redux/slice/tutorExamSlice";
import { setPendingInterviewArr } from "../../../../../redux/slice/tutorExamSlice";

const ExamArena = () => {
  const dispatch = useDispatch();

  const [itsClicked, setItsClicked] = useState("exam_arena");
  const [tabValue, setTabValue] = useState('academic');

  // Function to handle tab switching
  const switchTab = (event, newValue) => {
    setTabValue(newValue);
  };
  const [resSubmitted, setResSubmitted] = useState(false);

  const isGraded = useSelector((state) => state.exam.isGraded);
  const subAnswers = useSelector((state) => state.exam.examResultsArr);
  const pendingInterviewList = useSelector((state) => state.exam.pendingInterviewArr);

  console.log(isGraded, "is graded");

  const getSubjectiveAnswers = useCallback(async () => {
    try {
      const response = await axios.get(
        // "http://localhost:8600/api/tutorWeb/subjective-answers"
        "https://testapis4.el.r.appspot.com/api/tutorWeb/subjective-answers"
      );

      if (response.status === 201 || response.status === 200) {
        // setAnswer(response?.data?.data);
        if (response?.data?.data) {
          dispatch(setExamResultsArr(response?.data?.data));
        }
      }

      const InterviewResponse = await axios.get(
        "https://testapis4.el.r.appspot.com/api/tutorWeb/pending-interviews"
        // "https://testapis4.el.r.appspot.com/api/tutorWeb/subjective-answers"
      );

      if (InterviewResponse.status === 201 || response.status === 200) {
        // setAnswer(response?.data?.data);
        if (InterviewResponse?.data?.data) {
          dispatch(setPendingInterviewArr(InterviewResponse?.data?.data));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [resSubmitted]);

  useEffect(() => {
    if (!isGraded) {
      getSubjectiveAnswers();
    }
  }, [getSubjectiveAnswers, isGraded]);

  return (
    <>
      <Sidebar itsClicked={itsClicked} />
      <Header />
      <div>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "2rem",
          }}
          component="main"
          sx={{
            flexGrow: 1,
            py: 8,
            backgroundColor: "rgb(248 248 248)",
          }}
        >
          <Container
            maxWidth="lg"
            style={{ maxWidth: "940px", paddingBottom: "15rem" }}
          >
            <Typography sx={{ mb: 1 }} variant="h4">
              Exam Arena
            </Typography>
            {/* <div className="tabs">
              <button onClick={() => handleTabSwitch('Academic')} className={activeTab === 'Academic' ? 'active' : ''}>
                Academic
              </button>
              <button onClick={() => handleTabSwitch('Music')} className={activeTab === 'Music' ? 'active' : ''}>
                Music
              </button>
            </div> */}
             <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={switchTab} aria-label="Exam Tabs">
                  <Tab label="Academic" value="academic" />
                  <Tab label="Music" value="music" />
                </TabList>
              </Box>
              <TabPanel value="academic">
            <>
           <Box sx={{ pt: 1 }}>
              <ExamArenaTopSection />
            </Box>
            <Box sx={{ mt: 2 }}>
              <ExamArenaBottomSection answers={subAnswers} />
            </Box>
            <Box sx={{ mt: 2 }}>
              <ExamResults />
            </Box>
            </>
            </TabPanel>
            <TabPanel value="music">
            <>
            <Box sx={{ mt: 2 }}>
              <Interview answers={pendingInterviewList} resSubmitted = {resSubmitted} setResSubmitted = {setResSubmitted} />
            </Box>
            </>
            </TabPanel>
            </TabContext>
          </Container>
        </Box>
      </div>
    </>
  );
};

export default ExamArena;
